import { Box, type Theme, styled } from "@mui/material";
import type { Control, FieldValues, UseFormGetValues, UseFormSetValue } from "react-hook-form";

import AccountInfoDBC from "@/Dashboard/pages/MyAccount/components/AccountInfoDBC";

import AddMessageFormV2 from "../Forms/AddMessageFormV2";
import StaticMessageForm from "../Forms/StaticMessageForm";

const StyledContainer = styled(Box)(({ theme }: { theme: Theme }) => ({
  position: "relative",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#000",
  [theme.breakpoints.between("xs", "sm")]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
}));

const StyledFormContent = styled(Box)(({ theme }: { theme: Theme }) => ({
  margin: "auto",
  height: "100%",
  width: "300px",
  backgroundColor: "#000",
  alignItems: "center",
  [theme.breakpoints.between("xs", "sm")]: {
    width: "100%",
    height: "100%",
    margin: "unset",
    padding: 0,
  },
}));

interface DigitalBusinessCardContentProps {
  photo: string;
  name: string;
  email: string;
  phone: string;
  control?: Control<FieldValues>;
  getValues?: UseFormGetValues<FieldValues>;
  setValue?: UseFormSetValue<FieldValues>;
  validate?: () => Promise<void>;
  disabled?: boolean;
  isMessageFormShown?: boolean;
}

export default function DigitalBusinessCardContent({
  photo,
  name,
  email,
  phone,
  control,
  getValues = (() => ({})) as UseFormGetValues<FieldValues>,
  setValue = (() => {}) as UseFormSetValue<FieldValues>,
  validate = async () => {},
  disabled = false,
  isMessageFormShown = true,
}: DigitalBusinessCardContentProps) {
  return (
    <StyledContainer>
      <StyledFormContent>
        <AccountInfoDBC photo={photo} name={name} email={email} phone={phone} />
      </StyledFormContent>
      {isMessageFormShown && (
        <StyledFormContent>
          {disabled ? (
            <StaticMessageForm />
          ) : (
            <AddMessageFormV2
              control={control as unknown as Control<FieldValues>}
              getValues={getValues}
              setValue={setValue}
              validate={validate}
            />
          )}
        </StyledFormContent>
      )}
    </StyledContainer>
  );
}
